module.exports = "<p id=\"player\"></p>";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/markup/html/youtube_player.html
 ** module id = 52
 ** module chunks = 0
 **/